﻿import { ValgStateActionTypes, ValgState, UPDATE_VALG } from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { VeilederNordenAppState } from '..';
import { AnyAction } from 'redux';
import { setVisning } from '../Resultat/Actions';
import VarighetTypeValg from '../../Utilities/VarighetTypeValg';
import BetaleTypeValg from '../../Utilities/BetaleTypeValg';

export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export const updateVisning = (): ThunkAction<void, VeilederNordenAppState, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<VeilederNordenAppState, {}, AnyAction>, getState: () => VeilederNordenAppState): void => {
        const currentState = getState();

        const visBoksB = visB(currentState);
        const visBoksBx = visBx(currentState);
        const visBoksC = visC(currentState);
        const visBoksD = visD(currentState);
        const visBetPlan = visPlan(currentState);
        dispatch(setVisning({ visBoksB, visBoksBx, visBoksC, visBoksD, visBetPlan }));
    };
};

const visB = (state: VeilederNordenAppState): boolean => {
    if(state.valg.aVarighet !== null && state.valg.aVarighet !== undefined && state.valg.aVarighet.value === VarighetTypeValg.a1_hele)
        return true;

    return false;
};

const visBx = (state: VeilederNordenAppState): boolean => {
    if(state.valg.aVarighet !== null && state.valg.aVarighet !== undefined && state.valg.aVarighet.value !== VarighetTypeValg.a1_hele)
        return true;
        
    return false;
};

const visC = (state: VeilederNordenAppState): boolean => {
    if(state.valg.bBetale !== null && state.valg.bBetale !== undefined && state.valg.bBetale.value === BetaleTypeValg.a1_ja)
        return true;

    return false;
};

const visD = (state: VeilederNordenAppState): boolean => {
    let maksSkolepengebelop: number = 0;
    if(state.satser?.SATS_ST01_SKOLEPENGESTOTTE_MAKS_PER_AR_NORDEN !== undefined) {
        if(state.valg.aVarighet?.value === VarighetTypeValg.a1_hele) {
            maksSkolepengebelop = state.satser?.SATS_ST01_SKOLEPENGESTOTTE_MAKS_PER_AR_NORDEN;
        } else {
            maksSkolepengebelop = state.satser?.SATS_ST01_SKOLEPENGESTOTTE_MAKS_PER_AR_NORDEN / 2;
        }
    }

    if((visC(state) && state.valg.cSkolepengerBelop !== null && state.valg.cSkolepengerBelop !== undefined && state.valg.cSkolepengerBelop <= maksSkolepengebelop) 
        || (state.valg.bBetale !== null && state.valg.bBetale !== undefined && state.valg.bBetale.value === BetaleTypeValg.a2_nei))
        return true;

    return false;
};

const visPlan = (state: VeilederNordenAppState): boolean => {
    if(visD(state) && state.valg.visBetPlan)
        return true;

    return false;
}
